
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import Colours from "@/utilities/Colours";

    @Component({})
    export default class ColourSwatch extends Vue {

        // mounted(): void {
        // }

        @Prop({ default: "#888" }) value!: string;

        @Prop({ default: 80 }) width!: number|string;

        @Prop({ default: 40 }) height!: number|string;

        get text(): string {
            return `${Colours.fullHex(this.value)}`
        }

        get style(): Record<string, string> {
            return { 
                backgroundColor: this.value, 
                width: `${+this.width || 80}px`, 
                height: `${+this.height || 40}px`,
                lineHeight: `${+this.height || 40}px`,
                color: `${Colours.isDark(this.value) ? "#DDD" : "#666"}`
            }
        }

    }
